import { render, staticRenderFns } from "./LoginWrapper.vue?vue&type=template&id=258d22d2&scoped=true&"
import script from "./LoginWrapper.vue?vue&type=script&lang=js&"
export * from "./LoginWrapper.vue?vue&type=script&lang=js&"
import style0 from "./LoginWrapper.vue?vue&type=style&index=0&id=258d22d2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "258d22d2",
  null
  
)

export default component.exports